import { useSelector } from "react-redux";
import { PFXLandingSubtype } from "../../../../models/Interfaces";
import { LandingComponent } from "../../../../redux/slices/landingSlice";
import { selectInitCatalog } from "../../../../redux/slices/templateSlice";
import Category from "./variants/Category";
import Expanded from "./variants/Expanded";
import Multiple from "./variants/Multiple";

interface IUpselling {
  component: LandingComponent;
}

const Upselling = ({ component }: IUpselling) => {
  const initCatalogSupervisor = useSelector(selectInitCatalog);

  switch (component.subtype) {
    case PFXLandingSubtype.CATEGORY:
      return (
        <Category data={component.data} id={component.id} loading={initCatalogSupervisor.status !== "succeeded"} />
      );
    case PFXLandingSubtype.EXPANDED:
      return (
        <Expanded data={component.data} id={component.id} loading={initCatalogSupervisor.status !== "succeeded"} />
      );

    case PFXLandingSubtype.MULTIPLE:
      return (
        <Multiple data={component.data} id={component.id} loading={initCatalogSupervisor.status !== "succeeded"} />
      );
    default:
      return (
        <Expanded data={component.data} id={component.id} loading={initCatalogSupervisor.status !== "succeeded"} />
      );
  }
};
export default Upselling;
